webpackJsonp([1],Array(116).concat([
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_demo_demo1__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_demo_demo1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_demo_demo1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_demo_demo2__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_demo_demo2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_demo_demo2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_demo_demo3__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_demo_demo3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_demo_demo3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_demo_about__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_demo_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_demo_about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_pagination_demo__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_pagination_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_pagination_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_tabs_demo__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_tabs_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_tabs_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_dropdown_demo__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_dropdown_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_dropdown_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_datepicker_demo__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_datepicker_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_datepicker_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_select_demo__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_select_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_components_select_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_upload_demo__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_upload_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_components_upload_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_components_slide_demo__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_components_slide_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_components_slide_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pluginsDemo_message__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pluginsDemo_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pluginsDemo_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pluginsDemo_alert__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pluginsDemo_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_pluginsDemo_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pluginsDemo_confirm__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pluginsDemo_confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_pluginsDemo_confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pluginsDemo_loading__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pluginsDemo_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_pluginsDemo_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_element_button__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_element_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_element_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_element_tag__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_element_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_element_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_element_input__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_element_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_element_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_element_radio__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_element_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_element_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_element_checkbox__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_element_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_element_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_element_switch__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_element_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_element_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_element_table__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_element_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_element_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_grid_grid__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_grid_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_grid_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_helper_color__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_helper_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_helper_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_helper_helper__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_helper_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_helper_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_helper_text__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_helper_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_helper_text__);




































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/', name: 'Home', component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a }, { path: '/about', name: 'About', component: __WEBPACK_IMPORTED_MODULE_6__components_demo_about___default.a }, { path: '/demo1', name: 'Demo1', component: __WEBPACK_IMPORTED_MODULE_3__components_demo_demo1___default.a }, { path: '/demo2', name: 'Demo2', component: __WEBPACK_IMPORTED_MODULE_4__components_demo_demo2___default.a }, { path: '/demo3', name: 'Demo3', component: __WEBPACK_IMPORTED_MODULE_5__components_demo_demo3___default.a }, { path: '/pagination-demo', name: 'Pagination', component: __WEBPACK_IMPORTED_MODULE_7__components_components_pagination_demo___default.a }, { path: '/tabs-demo', name: 'Tabs', component: __WEBPACK_IMPORTED_MODULE_8__components_components_tabs_demo___default.a }, { path: '/dropdown-demo', name: 'Dropdown', component: __WEBPACK_IMPORTED_MODULE_9__components_components_dropdown_demo___default.a }, { path: '/datepicker-demo', name: 'Datepicker', component: __WEBPACK_IMPORTED_MODULE_10__components_components_datepicker_demo___default.a }, { path: '/select-demo', name: 'Select', component: __WEBPACK_IMPORTED_MODULE_11__components_components_select_demo___default.a }, { path: '/upload-demo', name: 'Upload', component: __WEBPACK_IMPORTED_MODULE_12__components_components_upload_demo___default.a }, { path: '/slide-demo', name: 'Slide', component: __WEBPACK_IMPORTED_MODULE_13__components_components_slide_demo___default.a }, { path: '/message', name: 'Message', component: __WEBPACK_IMPORTED_MODULE_14__components_pluginsDemo_message___default.a }, { path: '/alert', name: 'Alert', component: __WEBPACK_IMPORTED_MODULE_15__components_pluginsDemo_alert___default.a }, { path: '/confirm', name: 'Confirm', component: __WEBPACK_IMPORTED_MODULE_16__components_pluginsDemo_confirm___default.a }, { path: '/loading', name: 'Loading', component: __WEBPACK_IMPORTED_MODULE_17__components_pluginsDemo_loading___default.a }, { path: '/button', name: 'Button', component: __WEBPACK_IMPORTED_MODULE_18__components_element_button___default.a }, { path: '/tag', name: 'Tag', component: __WEBPACK_IMPORTED_MODULE_19__components_element_tag___default.a }, { path: '/input', name: 'Input', component: __WEBPACK_IMPORTED_MODULE_20__components_element_input___default.a }, { path: '/radio', name: 'Radio', component: __WEBPACK_IMPORTED_MODULE_21__components_element_radio___default.a }, { path: '/checkbox', name: 'Checkbox', component: __WEBPACK_IMPORTED_MODULE_22__components_element_checkbox___default.a }, { path: '/switch', name: 'Switch', component: __WEBPACK_IMPORTED_MODULE_23__components_element_switch___default.a }, { path: '/table', name: 'Table', component: __WEBPACK_IMPORTED_MODULE_24__components_element_table___default.a }, { path: '/color', name: 'Color', component: __WEBPACK_IMPORTED_MODULE_26__components_helper_color___default.a }, { path: '/grid', name: 'Grid', component: __WEBPACK_IMPORTED_MODULE_25__components_grid_grid___default.a }, { path: '/helper', name: 'Helper', component: __WEBPACK_IMPORTED_MODULE_27__components_helper_helper___default.a }, { path: '/text', name: 'Text', component: __WEBPACK_IMPORTED_MODULE_28__components_helper_text___default.a }]
}));

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(337)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(394),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_viui__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_viui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_viui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(116);







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_viui___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive('prettify', {
  inserted: function inserted() {
    window.prettyPrint();
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      active: null,
      activeNode: null,
      menu: [{
        title: 'Demo',
        icon: 'fa fa-home',
        nodes: [{ name: 'Demo1', icon: 'fa fa-laptop', link: '/demo1' }, { name: 'Demo2', icon: 'fa fa-laptop', link: '/demo2' }, { name: 'Demo3', icon: 'fa fa-laptop', link: '/demo3' }]
      }, {
        title: '组件',
        icon: 'fa fa-star',
        nodes: [{ name: 'Dropdown 下拉按钮', icon: 'fa fa-caret-down', link: '/dropdown-demo' }, { name: 'Select 下拉框', icon: 'fa fa-angle-down', link: '/select-demo' }, { name: 'Pagination 分页器', icon: 'fa fa-ellipsis-h', link: '/pagination-demo' }, { name: 'Tab 选项卡', icon: 'fa fa-clone', link: '/tabs-demo' }, { name: 'Upload 上传组件', icon: 'fa fa-upload', link: '/upload-demo' }, { name: 'Slide 幻灯片', icon: 'fa fa-image', link: '/slide-demo' }, { name: 'Datepicker 日期选择器', icon: 'fa fa-calendar', link: '/datepicker-demo' }]
      }, {
        title: '插件',
        icon: 'fa fa-arrows-alt',
        nodes: [{ name: 'Message 消息', icon: '', link: '/message' }, { name: 'Alert 弹窗提醒', icon: '', link: '/alert' }, { name: 'Confirm 确认框', icon: '', link: '/confirm' }, { name: 'Loading 加载动画', icon: '', link: '/loading' }]
      }, {
        title: '布局',
        icon: 'fa fa-align-left',
        nodes: [{ name: 'Flex-grid 栅格系统', icon: 'fa fa-align-left', link: '/grid' }]
      }, {
        title: '元素',
        icon: 'fa fa-cubes',
        nodes: [{ name: 'Button 按钮', icon: 'fa fa-hand-pointer-o', link: '/button' }, { name: 'Tag 标签', icon: 'fa fa-tag', link: '/tag' }, { name: 'Input 输入框', icon: 'fa fa-italic', link: '/input' }, { name: 'Radio 单选按钮', icon: 'fa fa-circle-o', link: '/radio' }, { name: 'CheckBox 复选框', icon: 'fa fa-check-square-o', link: '/checkbox' }, { name: 'Switch 开关', icon: 'fa fa-toggle-off', link: '/switch' }, { name: 'Table 表格', icon: 'fa fa-table', link: '/table' }]
      }, {
        title: '帮助类',
        icon: 'fa fa-wrench',
        nodes: [{ name: 'Colors Metro色系', icon: 'fa fa-sticky-note-o', link: '/color' }, { name: 'Common 通用', icon: 'fa fa-gear', link: '/helper' }, { name: 'Text 文本', icon: 'fa fa-gear', link: '/text' }]
      }, {
        title: '关于',
        icon: 'fa fa-info-circle',
        nodes: [{ name: 'About', icon: '', link: '/about' }]
      }],
      menuHeight: 0
    };
  },
  created: function created() {
    var _this = this;

    this.initMenu();

    this.$nextTick(function () {
      _this.menuHeight = _this.$refs.menu.offsetHeight;
    });
    window.onresize = function () {
      _this.menuHeight = _this.$refs.menu.offsetHeight;
    };
  },

  watch: {
    active: function active() {
      if (this.active.nodes.length > 0) {
        this.activeNode = this.active.nodes[0];
      } else {
        this.activeNode = null;
      }
    },
    activeNode: function activeNode() {
      var link = this.activeNode ? this.activeNode.link : '/';
      this.$router.push({ path: link });
    }
  },
  methods: {
    initMenu: function initMenu() {
      if (this.menu.length > 0) {
        this.active = this.menu[0];
        if (this.menu[0].nodes.length > 0) {
          this.activeNode = this.menu[0].nodes[0];
        }
      }
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      moment: new Date().getTime()
    };
  },

  watch: {
    moment: function moment() {
      var date = new Date(this.moment);
      var msg = '\u4F60\u9009\u62E9\u4E86' + date.getFullYear() + '\u5E74' + (date.getMonth() + 1) + '\u6708' + date.getDate() + '\u65E5';
      this.$message({
        caption: '时间选择',
        content: msg,
        type: 'info'
      });
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menu: [{ value: 0, content: 'Action1' }, { value: 1, content: 'Action2' }, { value: 2, content: 'Action3' }, { value: 3, content: 'Action4' }, { value: 4, content: 'Action5', disabled: true }, { value: 5, content: 'Action6' }]
    };
  },

  methods: {
    choice: function choice(val) {
      this.$message({
        caption: '成功',
        content: '\u4F60\u9009\u62E9\u4E86' + this.menu[val].content,
        type: 'info'
      });
    }
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      text: '默认第1页'
    };
  },

  methods: {
    go: function go(n) {
      this.$message('\u4F60\u9009\u62E9\u4E86\u7B2C' + n + '\u9875');
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      options: [{ value: 1, text: '中国工商银行' }, { value: 2, text: '中国农业银行' }, { value: 3, text: '中国建设银行' }, { value: 4, text: '中国交通银行' }, { value: 5, text: '招商银行' }, { value: 6, text: '平安银行' }, { value: 7, text: '农村信用社' }, { value: 8, text: '华夏银行' }, { value: 9, text: '农商银行' }, { value: 10, text: '浦发银行' }],
      selected: { value: 3, text: '中国建设银行' }
    };
  },

  watch: {
    selected: function selected() {
      this.$message({
        caption: '提示',
        content: '\u4F60\u9009\u62E9\u4E86' + this.selected.text,
        type: 'alert'
      });
    }
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      list: [{
        imgUrl: 'https://raw.githubusercontent.com/watson-yan/watson-yan.github.io/master/ViUI/static/imgs/1.jpg',
        url: ''
      }, {
        imgUrl: 'https://raw.githubusercontent.com/watson-yan/watson-yan.github.io/master/ViUI/static/imgs/2.jpg',
        url: ''
      }, {
        imgUrl: 'https://raw.githubusercontent.com/watson-yan/watson-yan.github.io/master/ViUI/static/imgs/3.jpg',
        url: ''
      }, {
        imgUrl: 'https://raw.githubusercontent.com/watson-yan/watson-yan.github.io/master/ViUI/static/imgs/4.jpg',
        url: ''
      }]
    };
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      list: [{ name: 'div1' }, { name: 'div2' }],
      value: 'div1'
    };
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    fileChanged: function fileChanged(file) {
      var msg = file ? '\u6587\u4EF6\u540D\uFF1A' + file.name : '没有选取任何文件';
      var msgType = file ? 'success' : 'warning';
      this.$message({
        content: msg,
        type: msgType
      });
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, exports) {



/***/ }),
/* 131 */
/***/ (function(module, exports) {



/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      list: [{ name: 'Sales Order' }, { name: 'Purchase Order' }, { name: 'Products' }],
      active: 'Sales Order',
      options: [{ value: 0, text: 'Category' }, { value: 1, text: 'Category1' }, { value: 2, text: 'Category2' }, { value: 3, text: 'Category3' }, { value: 4, text: 'Category4' }],
      imgList: [{
        imgUrl: 'https://raw.githubusercontent.com/watson-yan/watson-yan.github.io/master/ViUI/static/imgs/1.jpg',
        url: ''
      }, {
        imgUrl: 'https://raw.githubusercontent.com/watson-yan/watson-yan.github.io/master/ViUI/static/imgs/2.jpg',
        url: ''
      }, {
        imgUrl: 'https://raw.githubusercontent.com/watson-yan/watson-yan.github.io/master/ViUI/static/imgs/3.jpg',
        url: ''
      }, {
        imgUrl: 'https://raw.githubusercontent.com/watson-yan/watson-yan.github.io/master/ViUI/static/imgs/4.jpg',
        url: ''
      }]
    };
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      options: [{ value: 0, text: 'Microsoft' }, { value: 1, text: 'Google' }, { value: 2, text: 'Amazon' }, { value: 3, text: 'Facebook' }, { value: 4, text: 'Apple' }]
    };
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  created: function created() {}
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {



/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      className: []
    };
  },

  computed: {
    clsName: function clsName() {
      return 'table ' + this.className.join(' ');
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    alert: function alert(alertType) {
      var component = this;
      component.$alert({
        caption: '组件 props 原子化',
        content: '传递过于复杂的对象使得我们不能够清楚的知道哪些属性或方法被自定义组件使用，这使得代码难以重构和维护',
        type: alertType
      }).then(function () {
        component.$message({
          caption: '回调显示',
          content: '如果有回调就会显示我了',
          type: alertType
        });
      });
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      this.$confirm('你是否通过了终极考验你是否通过了终极考验你是否通过了终极考验你是否通过了终极考验？').then(function () {
        _this.$message({
          caption: '通过',
          content: '恭喜你，通过了考验',
          type: 'success'
        });
      }).catch(function () {
        _this.$message({
          caption: '拒绝',
          content: '很遗憾，你被拒绝了',
          type: 'alert'
        });
      });
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    showLoading: function showLoading() {
      var _this = this;

      this.$showLoading();
      setTimeout(function () {
        _this.$hideLoading();
      }, 5000);
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    showMessage: function showMessage(msgType) {
      var _this = this;

      this.$message({
        caption: 'Message Title',
        content: '这里是展示Message的地方',
        type: msgType,
        duration: 8000
      }).then(function () {
        _this.$message({
          caption: 'Message Title',
          content: '这里是展示Message的地方',
          type: 'warning',
          duration: 8000
        });
      });
    }
  }
});

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(398),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(408),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(338)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(395),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(330)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(406),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(333)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(390),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(334)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(335)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(392),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(407),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(342)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(399),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(401),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(400),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(410),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(409),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(340)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(397),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(404),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(389),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(403),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(345)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(402),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(332)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(405),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(396),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(336)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(393),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Slide 幻灯片")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "250px",
      "width": "500px"
    }
  }, [_c('slide', {
    attrs: {
      "list": _vm.list,
      "duration": 5000
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Html代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div style=\"height: 250px; width: 500px;\">\n  <slide :list=\"list\" :duration=\"5000\"></slide>\n</div>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Script代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("  export default {\n    data() {\n      return {\n        list: [\n          // 传入的数据格式:\n          // imgUrl为图片地址, url为点击图片时的跳转\n          { imgUrl: '/static/imgs/1.jpg', url: '' },\n          { imgUrl: '/static/imgs/2.jpg', url: '' },\n          { imgUrl: '/static/imgs/3.jpg', url: '' },\n          { imgUrl: '/static/imgs/4.jpg', url: '' }\n        ]\n      }\n    }\n  }\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("list")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("幻灯片的图片列表")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("duration")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("5000")]), _vm._v(" "), _c('td', [_vm._v("每张图片的停留时间")])])])])
}]}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Datepicker 日期选择")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_c('datepicker', {
    attrs: {
      "moment": _vm.moment
    },
    on: {
      "update:moment": function($event) {
        _vm.moment = $event
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Html代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--直接使用datepicker标签, datepicker的宽度由外层容器的宽度决定(占满)-->\n<div style=\"width: 200px;\">\n<datepicker :moment.sync=\"moment\"></datepicker>\n</div>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("js代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v(" data() {\n  return {\n    // 为了解决js在计算时间时跟后端算法不同，采用了毫秒计数\n    moment: new Date().getTime()\n  }\n}\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("moment")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("默认时间(为了配合双向绑定，改为必填项)")])])])])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Alert 弹窗提醒")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.alert()
      }
    }
  }, [_vm._v("Default Alert")]), _vm._v(" "), _c('button', {
    staticClass: "button info",
    on: {
      "click": function($event) {
        _vm.alert('info')
      }
    }
  }, [_vm._v("Alert(Info)")]), _vm._v(" "), _c('button', {
    staticClass: "button success",
    on: {
      "click": function($event) {
        _vm.alert('success')
      }
    }
  }, [_vm._v("Alert(Success)")]), _vm._v(" "), _c('button', {
    staticClass: "button danger",
    on: {
      "click": function($event) {
        _vm.alert('error')
      }
    }
  }, [_vm._v("Alert(Error)")]), _vm._v(" "), _c('button', {
    staticClass: "button warning",
    on: {
      "click": function($event) {
        _vm.alert('warning')
      }
    }
  }, [_vm._v("Alert(Warning)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Script")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("this.$alert({\n      caption: 'Alert Title',   // 提示Title（可不填）\n      content: 'Alert Content',       // 提示内容\n      type: 'Alert Type',      // 消息类型：default(不赋值)，info, success, error, warning\n  }).then(() => {    // 使用了Promise语法糖, 点击确定后可以触发回调\n    // 回调\n  })")])])])
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Tabs 选项卡")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('tabs', {
    attrs: {
      "list": _vm.list,
      "value": _vm.value
    },
    on: {
      "update:value": function($event) {
        _vm.value = $event
      }
    }
  }, [_c('div', {
    staticClass: "padding15 bg-grayLighter",
    slot: "div1"
  }, [_vm._v("我是div1")]), _vm._v(" "), _c('div', {
    staticClass: "padding15 bg-grayLighter",
    slot: "div2"
  }, [_vm._v("我是div2")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("HTML代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--:value.sync 为必填(以配合双向绑定)-->\n<tabs :list=\"list\" :value.sync=\"value\">\n  <!--slot的值为该容器所对应的name-->\n  <div slot=\"div1\" class=\"padding15 bg-grayLighter\">我是div1</div>\n  <div slot=\"div2\" class=\"padding15 bg-grayLighter\">我是div2</div>\n</tabs>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Script代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("export default {\n  data() {\n    return {\n      list: [\n        { name: 'div1' },\n        { name: 'div2' }\n      ],\n      value: 'div1' // 需要激活的容器name\n    }\n  }\n}\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("list")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("选项卡的name列表")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("激活的Panel(为了配合双向绑定，改为必填项)")])])])])
}]}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Pagination 分页器")]), _vm._v(" "), _c('pagination', {
    attrs: {
      "total": 120,
      "next": _vm.go,
      "show-total": true
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div>\n  <!--全局引入后的用法-->\n  <pagination :total=\"120\" :next=\"go\" :show-total=\"true\"></pagination>\n</div>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("pn")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("当前页(默认第1页)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("total")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("总共数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("分页大小(每页多少条数据)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("next")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("选择页面之后的回调")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-total")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("是否显示总页数")])])])])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Upload 上传组件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "220px"
    }
  }, [_c('upload', {
    attrs: {
      "name": 'img'
    },
    on: {
      "fileChanged": _vm.fileChanged
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("HTML代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div style=\"width: 220px;\">\n  <!--宽度由外层容器决定，总是占满外层容器-->\n  <upload :name=\"'img'\" @fileChanged=\"fileChanged\"></upload>\n</div>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Script代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("data() {\n  return {}\n},\nmethods: {\n  fileChanged(file) {\n    const msg = file ? `文件名：${file.name}` : '没有选取任何文件'\n    const msgType = file ? 'success' : 'warning'\n    this.$message({\n      content: msg,\n      type: msgType\n    })\n  }\n}\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Binding attributes 绑定属性")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("input[type=\"file\"]标签的name, 用于嵌在form标签中使用")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Attribute Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Argument")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("fileChanged")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("file(选中的文件)")]), _vm._v(" "), _c('td', [_vm._v("文件变动后的回调事件")])])])])
}]}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("背景色用法:")]), _vm._v(" "), _c('div', {
    staticClass: "padding30 bg-blue align-center fg-white"
  }, [_vm._v("\n        background: blue\n    ")]), _vm._v(" "), _c('div', [_c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"bg-blue\">\n   background: blue\n</div>\n")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("字体颜色:")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<p class=\"fg-blue\">blue</p>\n<p class=\"fg-orange\">orange</p>\n<p class=\"fg-emerald\">emerald</p>\n")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "box flex-grid"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Metro colors 主色系")]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("\n        下面列出来的颜色可以用来充当背景色或文字颜色:\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("背景颜色: "), _c('span', {
    staticClass: "tag info"
  }, [_vm._v("bg-*")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("字体颜色: "), _c('span', {
    staticClass: "tag info"
  }, [_vm._v("fg-*")])]), _vm._v(" "), _c('ul', {
    staticClass: "row unstyled-list"
  }, [_c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-black"
  }, [_vm._v("black")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-white"
  }, [_vm._v("white")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lime"
  }, [_vm._v("lime")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-green"
  }, [_vm._v("green")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-emerald"
  }, [_vm._v("emerald")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-teal"
  }, [_vm._v("teal")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-blue"
  }, [_vm._v("blue")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-cyan"
  }, [_vm._v("cyan")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-cobalt"
  }, [_vm._v("cobalt")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-indigo"
  }, [_vm._v("indigo")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-violet"
  }, [_vm._v("violet")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-pink"
  }, [_vm._v("pink")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-magenta"
  }, [_vm._v("magenta")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-crimson"
  }, [_vm._v("crimson")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-red"
  }, [_vm._v("red")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-orange"
  }, [_vm._v("orange")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-amber"
  }, [_vm._v("amber")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-yellow"
  }, [_vm._v("yellow")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-brown"
  }, [_vm._v("brown")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-olive"
  }, [_vm._v("olive")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-steel"
  }, [_vm._v("steel")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-mauve"
  }, [_vm._v("mauve")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-taupe"
  }, [_vm._v("taupe")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-gray"
  }, [_vm._v("gray")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-dark"
  }, [_vm._v("dark")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darker"
  }, [_vm._v("darker")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkBrown"
  }, [_vm._v("darkBrown")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkCrimson"
  }, [_vm._v("darkCrimson")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkMagenta"
  }, [_vm._v("darkMagenta")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkIndigo"
  }, [_vm._v("darkIndigo")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkCyan"
  }, [_vm._v("darkCyan")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkCobalt"
  }, [_vm._v("darkCobalt")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkTeal"
  }, [_vm._v("darkTeal")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkEmerald"
  }, [_vm._v("darkEmerald")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkGreen"
  }, [_vm._v("darkGreen")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkOrange"
  }, [_vm._v("darkOrange")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkRed"
  }, [_vm._v("darkRed")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkPink"
  }, [_vm._v("darkPink")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkViolet"
  }, [_vm._v("darkViolet")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkBlue"
  }, [_vm._v("darkBlue")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightBlue"
  }, [_vm._v("lightBlue")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightRed"
  }, [_vm._v("lightRed")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightGreen"
  }, [_vm._v("lightGreen")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lighterBlue"
  }, [_vm._v("lighterBlue")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightTeal"
  }, [_vm._v("lightTeal")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightOlive"
  }, [_vm._v("lightOlive")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightOrange"
  }, [_vm._v("lightOrange")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightPink"
  }, [_vm._v("lightPink")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-grayDark"
  }, [_vm._v("grayDark")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-grayDarker"
  }, [_vm._v("grayDarker")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-grayLight"
  }, [_vm._v("grayLight")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-grayLighter"
  }, [_vm._v("grayLighter")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "fg-blue"
  }, [_vm._v("blue")]), _vm._v(" "), _c('p', {
    staticClass: "fg-orange"
  }, [_vm._v("orange")]), _vm._v(" "), _c('p', {
    staticClass: "fg-emerald"
  }, [_vm._v("emerald")])])
}]}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "bg-grayLighter padding10",
    staticStyle: {
      "font-size": "0.875rem"
    }
  }, [_vm._v("Home / demo1")]), _vm._v(" "), _c('h4', {
    staticClass: "margin5"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Panel")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "cell colspan3 padding5"
  }, [_c('div', {
    staticClass: "padding10 bg-red align-center fg-white"
  }, [_c('i', {
    staticClass: "fa fa-reorder",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _vm._v(" "), _c('p', [_vm._v("New Order")])])]), _vm._v(" "), _c('section', {
    staticClass: "cell colspan3 padding5"
  }, [_c('div', {
    staticClass: "padding10 bg-teal align-center fg-white"
  }, [_c('i', {
    staticClass: "fa fa-cube",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Products")])])]), _vm._v(" "), _c('section', {
    staticClass: "cell colspan3 padding5"
  }, [_c('div', {
    staticClass: "padding10 bg-lightBlue align-center fg-white"
  }, [_c('i', {
    staticClass: "fa fa-commenting-o",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Comments")])])]), _vm._v(" "), _c('section', {
    staticClass: "cell colspan3 padding5"
  }, [_c('div', {
    staticClass: "padding10 bg-violet align-center fg-white"
  }, [_c('i', {
    staticClass: "fa fa-random",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Bussiness")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "margin5"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Order")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "input-control text",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('input', {
    staticStyle: {
      "padding-right": "58px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table border bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Abby")]), _vm._v(" "), _c('td', [_vm._v("The npm command-line tool is bundled with Node.js")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jasmine")]), _vm._v(" "), _c('td', [_vm._v("Everything you see exists together in a delicate balance")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag alert"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Camille")]), _vm._v(" "), _c('td', [_vm._v("Whatever is worth doing is worth doing well")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag success"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vanessa")]), _vm._v(" "), _c('td', [_vm._v("In love folly is always sweet.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Magical")]), _vm._v(" "), _c('td', [_vm._v("The hard part isn’t making the decision. It’s living with it")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag warning"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "margin5"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Form")]), _vm._v(" "), _c('div', {
    staticClass: "demo1-form padding10"
  }, [_c('form', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "cell colspan6"
  }, [_c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan8"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your name"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan8"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your Phone"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan8"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your email"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sex")]), _vm._v(" "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Male")])]), _vm._v("\n                \n              "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Buy")])]), _vm._v("\n                \n              "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Register")])]), _vm._v("\n                \n              "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Ask Info")])])])]), _vm._v(" "), _c('section', {
    staticClass: "cell colspan6"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan8"
  }, [_c('textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "8"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row flex-just-end"
  }, [_c('section', {
    staticClass: "cell colspan2",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('button', {
    staticClass: "button primary"
  }, [_vm._v("Submit")])])])])])])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p'), _vm._v(" "), _c('tabs', {
    attrs: {
      "list": _vm.list,
      "value": _vm.active
    },
    on: {
      "update:value": function($event) {
        _vm.active = $event
      }
    }
  }, [_c('div', {
    slot: "Sales Order"
  }, [_c('section', {
    staticClass: "padding10"
  }, [_c('div', {
    staticClass: "input-control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Category")]), _vm._v(" "), _c('vi-select', {
    attrs: {
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button primary"
  }, [_vm._v("Search")])]), _vm._v(" "), _c('table', {
    staticClass: "table border bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Abby")]), _vm._v(" "), _c('td', [_vm._v("The npm command-line tool is bundled with Node.js")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jasmine")]), _vm._v(" "), _c('td', [_vm._v("Everything you see exists together in a delicate balance")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag alert"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Camille")]), _vm._v(" "), _c('td', [_vm._v("Whatever is worth doing is worth doing well")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag success"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vanessa")]), _vm._v(" "), _c('td', [_vm._v("In love folly is always sweet.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Magical")]), _vm._v(" "), _c('td', [_vm._v("The hard part isn’t making the decision. It’s living with it")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag warning"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Abby")]), _vm._v(" "), _c('td', [_vm._v("The npm command-line tool is bundled with Node.js")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jasmine")]), _vm._v(" "), _c('td', [_vm._v("Everything you see exists together in a delicate balance")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag alert"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Camille")]), _vm._v(" "), _c('td', [_vm._v("Whatever is worth doing is worth doing well")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag success"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "margin10"
  }, [_c('pagination', {
    attrs: {
      "total": 60
    }
  })], 1)]), _vm._v(" "), _c('div', {
    slot: "Purchase Order"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('slide', {
    attrs: {
      "list": _vm.imgList,
      "duration": 5000
    }
  })], 1)]), _vm._v(" "), _c('div', {
    slot: "Products"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "padding10 bg-grayLighter"
  }, [_vm._v("Form")]), _vm._v(" "), _c('form', {
    staticClass: "flex-grid",
    attrs: {
      "action": ""
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4"
  }, [_c('datepicker')], 1)]), _vm._v(" "), _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Company")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4"
  }, [_c('vi-select', {
    attrs: {
      "options": _vm.options
    }
  })], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4 input-control"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your name"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4 input-control"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your email"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4 input-control"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your phone number"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4"
  }, [_c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Male")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Female")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4"
  }, [_c('textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "4"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('section', {
    staticClass: "cell colspan8 row flex-just-center padding20"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Reset")]), _vm._v("   \n        "), _c('button', {
    staticClass: "button primary"
  }, [_vm._v("Submit")])])])
}]}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Message 消息")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showMessage()
      }
    }
  }, [_vm._v("Default Message")]), _vm._v(" "), _c('button', {
    staticClass: "button info",
    on: {
      "click": function($event) {
        _vm.showMessage('info')
      }
    }
  }, [_vm._v("Info Message")]), _vm._v(" "), _c('button', {
    staticClass: "button success",
    on: {
      "click": function($event) {
        _vm.showMessage('success')
      }
    }
  }, [_vm._v("Success Message")]), _vm._v(" "), _c('button', {
    staticClass: "button danger",
    on: {
      "click": function($event) {
        _vm.showMessage('alert')
      }
    }
  }, [_vm._v("Alert Message")]), _vm._v(" "), _c('button', {
    staticClass: "button warning",
    on: {
      "click": function($event) {
        _vm.showMessage('warning')
      }
    }
  }, [_vm._v("Warning Message")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Script")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("this.$message({\n      caption: 'Message Title',   // 消息Title（可不填）\n      content: 'Message Content',       // 消息主题\n      type: 'Message Type',      // 消息类型：default(不赋值)，info, success, alert, warning\n      duration: 5000      // 持续时间（默认5s关闭）\n  }).then(() => {    // 使用了Promise语法糖, 消息框消失后可以触发回调\n    // 回调\n  })")])])])
},staticRenderFns: []}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('article', [_c('div', {
    ref: "menu",
    staticClass: "nav-menu bg-darkBlue"
  }, [(_vm.active) ? _c('ul', {
    staticClass: "unstyled-list no-margin lv1-menu",
    style: ({
      minHeight: _vm.menuHeight + 'px'
    })
  }, _vm._l((_vm.menu), function(m) {
    return _c('li', {
      class: {
        'active': _vm.active == m
      },
      attrs: {
        "title": m.title
      },
      on: {
        "click": function($event) {
          _vm.active = m
        }
      }
    }, [_c('i', {
      class: m.icon
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "assistant",
    style: ({
      minHeight: _vm.menuHeight + 'px'
    })
  }, [_c('h3', {
    staticClass: "no-margin align-center"
  }, [_vm._v(_vm._s(_vm.active.title))]), _vm._v(" "), (_vm.activeNode) ? _c('ul', {
    staticClass: "unstyled-list no-margin lv2-menu"
  }, _vm._l((_vm.active.nodes), function(item) {
    return _c('li', {
      class: {
        'active': _vm.activeNode.name == item.name
      },
      on: {
        "click": function($event) {
          _vm.activeNode = item
        }
      }
    }, [_c('a', {
      staticClass: "text-ellipsis"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name))])])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "router-content"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('footer')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "flex-grid bg-dark"
  }, [_c('div', {
    staticClass: "row flex-just-sb"
  }, [_c('div', {
    staticClass: "intro fg-white"
  }, [_vm._v("\n        VIUI"), _c('small', {
    staticStyle: {
      "font-size": "14px",
      "font-style": "italic"
    }
  }, [_vm._v("Metro UI组件库 - Vue(2.x)")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-control text",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('input', {
    staticStyle: {
      "padding-right": "58px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "app-menu unstyled-list clearfix"
  }, [_c('li', {
    staticClass: "fg-white"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/watson-yan/viui",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Github [Stared me!]")])])])])])])
}]}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Select 下拉框")]), _vm._v(" "), _c('vi-select', {
    attrs: {
      "options": _vm.options,
      "selected": _vm.selected,
      "width": 220
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Html代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--直接使用vi-select标签-->\n<vi-select :options=\"options\" :selected.sync=\"selected\" :width=\"220\"></vi-select>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("js代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("export default {\n    data() {\n      return {\n        options: [\n          { value: 1, text: '中国工商银行' },\n          { value: 2, text: '中国农业银行' },\n          { value: 3, text: '中国建设银行' },\n          { value: 4, text: '中国交通银行' },\n          { value: 5, text: '招商银行' },\n          { value: 6, text: '平安银行' },\n          { value: 7, text: '农村信用社' },\n          { value: 8, text: '华夏银行' },\n          { value: 9, text: '农商银行' },\n          { value: 10, text: '浦发银行' }\n        ],\n        selected: { value: 3, text: '中国建设银行' }\n      }\n    },\n    watch: {\n      selected() {\n        this.$message({\n          caption: '提示',\n          content: `你选择了${this.selected.text}`,\n          type: 'alert'\n        })\n      }\n    }\n  }\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("选项列表{value: x, text: xxx}")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("selected.sync")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("默认选择项(options中的一项),可不传")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("200")]), _vm._v(" "), _c('td', [_vm._v("下拉框的宽度")])])])])
}]}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Loading 加载动画")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.showLoading
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('p', [_vm._v("Script")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("showLoading() {\n  this.$showLoading() // 显示加载框\n  setTimeout(() => {\n    this.$hideLoading()   // 关闭加载框\n  }, 5000)\n}")])])])
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Tag 标签")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--普通标签-->\n<span class=\"tag\">tag</span>\n<!--完成标签-->\n<span class=\"tag success\">sucess</span>\n<!--信息标签-->\n<span class=\"tag info\">info</span>\n<!--警告标签-->\n<span class=\"tag warning\">warning</span>\n<!--提醒标签-->\n<span class=\"tag alert\">alert</span>\n")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("tag")]), _vm._v(" "), _c('span', {
    staticClass: "tag success"
  }, [_vm._v("sucess")]), _vm._v(" "), _c('span', {
    staticClass: "tag info"
  }, [_vm._v("info")]), _vm._v(" "), _c('span', {
    staticClass: "tag warning"
  }, [_vm._v("warning")]), _vm._v(" "), _c('span', {
    staticClass: "tag alert"
  }, [_vm._v("alert")])])
}]}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  })
},staticRenderFns: []}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Checkbox 复选框")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"input-control checkbox\">\n  <input type=\"checkbox\" checked>\n  <span class=\"check\"></span>\n  <span class=\"caption\">苹果</span>\n</label>\n<label class=\"input-control checkbox\">\n  <input type=\"checkbox\">\n  <span class=\"check\"></span>\n  <span class=\"caption\">香蕉</span>\n</label>\n")])]), _vm._v(" "), _c('h5', {
    staticClass: "fg-gray"
  }, [_vm._v("Disabled状态")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("\n<label class=\"input-control checkbox\">\n  <input type=\"checkbox\" checked disabled>\n  <span class=\"check\"></span>\n  <span class=\"caption\">喜欢</span>\n</label>\n")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("你最喜欢的水果：")]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("苹果")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("香蕉")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("梨子")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("橘子")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("你喜欢我吗：")]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("喜欢")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("不喜欢")])])])
}]}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Radio 单选按钮")]), _vm._v(" "), _c('p', {}), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"form-group\">\n  <label class=\"label\">Gender:</label>\n\n  <!--Radio 最后的值是绑定在input[type=\"radio\"]上-->\n  <label class=\"input-control radio\">\n    <input type=\"radio\" name=\"gender\" checked>\n    <span class=\"check\"></span>\n    <span class=\"caption\">Male</span>\n  </label>\n<!--Radio-->\n  <label class=\"input-control radio\">\n    <input type=\"radio\" name=\"gender\">\n    <span class=\"check\"></span>\n    <span class=\"caption\">Female</span>\n  </label>\n</div>")])])]), _vm._v(" "), _c('h5', {
    staticClass: "fg-gray"
  }, [_vm._v("Disabled状态")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"input-control radio\">\n  <input type=\"radio\" name=\"radio\" disabled>\n  <span class=\"check\"></span>\n  <span class=\"caption\">Disabled状态</span>\n</label>\n")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Gender:")]), _vm._v(" "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Male")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Female")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radio"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Select me")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radio",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Disabled状态")])])
}]}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Text 文本框")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('form', {
    staticClass: "flex-grid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"row form-group\">\n  <label class=\"label align-right cell\">文本框</label>\n  <div class=\"input-control cell colspan4\">\n    <input type=\"text\">\n  </div>\n</div>\n<div class=\"row form-group\">\n  <label class=\"label align-right cell\">密码</label>\n  <div class=\"input-control cell colspan4\">\n    <input type=\"password\">\n  </div>\n</div> ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "no-margin fg-gray"
  }, [_vm._v("带Placehoder")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h5', {
    staticClass: "no-margin fg-gray"
  }, [_vm._v("Readonly 只读状态")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h5', {
    staticClass: "no-margin fg-gray"
  }, [_vm._v("Disabled 禁用状态")]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Text field states 文本框状态")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("1. error")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("2. warning")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("3. success")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("4. required")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"input-control error\">\n    <input type=\"text\">\n</div>\n<div class=\"input-control warning\">\n    <input type=\"text\">\n</div>\n<div class=\"input-control success\">\n    <input type=\"text\">\n</div>\n  <div class=\"input-control required\">\n  <input type=\"text\">\n</div>\n")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Input with buttons 带按钮的输入框")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"input-control text\" style=\"width: 300px;\">\n  <input type=\"text\" placeholder=\"Search ...\" style=\"padding-right: 58px;\">\n  <button class=\"button\">\n    <i class=\"fa fa-search\"></i></button>\n</div>\n")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("文本")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("密码")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "password"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "email",
      "placeholder": "请输入您的Email地址"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("Readonly")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "value": "Readonly",
      "readonly": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control error"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control warning"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control success"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control required"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control text",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('input', {
    staticStyle: {
      "padding-right": "58px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
}]}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Text 文本相关")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("1. text-ellipsis 文本超出容器显示省略号")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "fg-dark"
  }, [_vm._v("加上text-ellipsis类后")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div style=\"width:400px;\">\n  <p class=\"text-ellipsis\">\n    ISO-8859-1 的较低部分（从 1 到 127 之间的代码）是最初的 ASCII 字符集\n    （0-9 的数字，大写和小写英文字母表，以及一些特殊字符）\n  </p>\n</div>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("2. line-clamp* 超出多行显示省略号(该class只对webkit内核的浏览器有效)")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "fg-dark"
  }, [_vm._v("line-clamp2")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "fg-dark"
  }, [_vm._v("line-clamp3")]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fg-gray"
  }, [_c('span', {
    staticClass: "fg-dark"
  }, [_vm._v("原文:")]), _vm._v("\n      ISO-8859-1 的较低部分（从 1 到 127 之间的代码）是最初的 ASCII 字符集（0-9 的数字，大写和小写英文字母表，以及一些特殊字符）\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box padding5",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('p', {
    staticClass: "text-ellipsis"
  }, [_vm._v("\n          ISO-8859-1 的较低部分（从 1 到 127 之间的代码）是最初的 ASCII 字符集（0-9 的数字，大写和小写英文字母表，以及一些特殊字符）\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fg-gray"
  }, [_c('span', {
    staticClass: "fg-dark"
  }, [_vm._v("原文:")]), _vm._v("\n      无论是窗外的丝丝凉意，还是独行路上的阵阵微风，有种味道会让你想起那些欢声笑语，那些温暖涟漪，原来人生最怀念不过，一起吃着火锅听着歌\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box padding5",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('p', {
    staticClass: "line-clamp2"
  }, [_vm._v("\n        无论是窗外的丝丝凉意，还是独行路上的阵阵微风，有种味道会让你想起那些欢声笑语，那些温暖涟漪，原来人生最怀念不过，一起吃着火锅听着歌\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box padding5",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('p', {
    staticClass: "line-clamp3"
  }, [_vm._v("\n        无论是窗外的丝丝凉意，还是独行路上的阵阵微风，有种味道会让你想起那些欢声笑语，那些温暖涟漪，原来人生最怀念不过，一起吃着火锅听着歌\n      ")])])
}]}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Common 通用")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("1. Margin相关")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"no-margin\"></div>\n<div class=\"margin5\"></div>\n<div class=\"margin10\"></div>\n<div class=\"margin20 no-margin-left\"></div>\n<div class=\"margin20 no-margin-bottom\"></div>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("2. Padding相关")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"no-padding\"></div>\n<div class=\"padding5\"></div>\n<div class=\"padding10\"></div>\n<div class=\"padding20 no-padding-left\"></div>\n<div class=\"padding20 no-padding-bottom\"></div>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("3. Float 相关")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--clearfix清除父元素浮动-->\n<article class=\"clearfix\">\n<!--pull-left向左浮动-->\n  <section class=\"pull-left\">.pull-left</section>\n  <!--pull-right 向右浮动-->\n  <section class=\"pull-right\">.pull-right</section>\n</article>")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("4. List 列表(清除padding-left和list-style)")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<ul class=\"unstyled-list\">\n  <li>Item1</li>\n  <li>Item2</li>\n  <li>Item3</li>\n  <li>Item4</li>\n  <li>Item5</li>\n</ul>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("5. Shadow 阴影")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"shadow\">shadow</div>\n<div class=\"block-shadow\">block-shadow</div>\n<div class=\"bottom-shadow\">bottom-shadow</div>\n<div class=\"text-shadow\">text-shadow</div>\n")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan no-margin"
  }, [_vm._v("\n        .no-margin\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin5"
  }, [_vm._v("\n        .margin5\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin10"
  }, [_vm._v("\n        .margin10\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin15"
  }, [_vm._v("\n        .margin15\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20"
  }, [_vm._v("\n        .margin20\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20 no-margin-top"
  }, [_vm._v("\n        .no-margin-top\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20 no-margin-right"
  }, [_vm._v("\n        .no-margin-right\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20 no-margin-bottom"
  }, [_vm._v("\n        .no-margin-bottom\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20 no-margin-left"
  }, [_vm._v("\n        .no-margin-left\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding0"
  }, [_vm._v("\n        .padding0\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding5"
  }, [_vm._v("\n        .padding5\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding10"
  }, [_vm._v("\n        .padding10\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding15"
  }, [_vm._v("\n        .padding15\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20"
  }, [_vm._v("\n        .padding20\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20 no-padding-top"
  }, [_vm._v("\n        .no-padding-top\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20 no-padding-right"
  }, [_vm._v("\n        .no-padding-right\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20 no-padding-bottom"
  }, [_vm._v("\n        .no-padding-bottom\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20 no-padding-left"
  }, [_vm._v("\n        .no-padding-left\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "clearfix",
    staticStyle: {
      "padding": "10px",
      "border": "1px solid #eee"
    }
  }, [_c('section', {
    staticClass: "pull-left padding15 bg-amber fg-white"
  }, [_vm._v("\n        .pull-left\n      ")]), _vm._v(" "), _c('section', {
    staticClass: "pull-right padding15 bg-amber fg-white"
  }, [_vm._v("\n        .pull-right\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "unstyled-list"
  }, [_c('li', [_vm._v("Item1")]), _vm._v(" "), _c('li', [_vm._v("Item2")]), _vm._v(" "), _c('li', [_vm._v("Item3")]), _vm._v(" "), _c('li', [_vm._v("Item4")]), _vm._v(" "), _c('li', [_vm._v("Item5")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-box"
  }, [_c('div', {
    staticClass: "margin10 padding20 shadow "
  }, [_vm._v("\n        .shadow\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-box"
  }, [_c('div', {
    staticClass: "margin10 padding20 block-shadow"
  }, [_vm._v("\n        .block-shadow\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-box"
  }, [_c('div', {
    staticClass: "margin10 padding20 bottom-shadow"
  }, [_vm._v("\n        .bottom-shadow\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-box"
  }, [_c('div', {
    staticClass: "margin10 padding20 text-shadow"
  }, [_vm._v("\n        .text-shadow\n      ")])])
}]}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Flex grid 栅格布局")]), _vm._v(" "), _c('section', {
    staticClass: "box flex-grid demo-grid"
  }, [_c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("默认cell大小")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<article class=\"flex-grid\">\n    <!--row相当于12个普通cell的宽度，也就是100%-->\n    <div class=\"row\">\n        <div class=\"cell bg-teal\">cell</div>\n    </div>\n</article>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("多个cell")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("占5列的cell")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_vm._m(3)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "fg-darkCyan"
  }, [_vm._v("Justify 对齐方式")]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("justify-start 左对齐")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("justify-end 右对齐")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("justify-center 居中")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("space-around 平均分布(左右间隔相等)")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("space-between 两端对齐")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("\n<!--justify-start 左对齐-->\n<div class=\"row\"></div>\n<!--justify-end 右对齐-->\n<div class=\"row flex-just-end\"></div>\n<!--justify-center 居中-->\n<div class=\"row flex-just-center\"></div>\n<!--space-around 平均分布(左右间隔相等)-->\n<div class=\"row flex-just-sa\"></div>\n<!--space-between 两端对齐-->\n<div class=\"row flex-just-sb\"></div>\n")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")]), _vm._v(" "), _c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")]), _vm._v(" "), _c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")]), _vm._v(" "), _c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")]), _vm._v(" "), _c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell colspan5 bg-amber"
  }, [_vm._v("cell colspan5")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('code', {
    pre: true
  }, [_vm._v("\n<article class=\"flex-grid\">\n    <div class=\"row\">\n        <div class=\"cell bg-teal\">cell</div>\n        <div class=\"cell bg-teal\">cell</div>\n        <div class=\"cell bg-teal\">cell</div>\n        <div class=\"cell bg-teal\">cell</div>\n        <div class=\"cell bg-teal\">cell</div>\n    </div>\n\n    <div class=\"row\">\n        <!--"), _c('span', {
    attrs: {
      "class": "tag alert fg-white"
    }
  }, [_vm._v("colspan*")]), _vm._v("表示占几列-->\n        <div class=\"cell colspan5 bg-amber\">cell colspan5</div>\n    </div>\n</article>\n")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-just-end"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-just-center"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-just-sa"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-just-sb"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
}]}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Confirm 确认框")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.confirm()
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Script")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("this.$confirm({\n      caption: 'confirm Title',   // 确认框Title（可不填）\n      content: 'confirm Content',       // 内容\n  }).then(() => {    // 使用了Promise语法糖, 点击确定后可以触发回调\n    // 确认的回调\n  }).catch(() => {\n    // 取消的回调\n  })")])])])
},staticRenderFns: []}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("关于框架")]), _vm._v(" "), _c('h4', {
    staticClass: "fg-cyan no-margin-bottom"
  }, [_vm._v("Metro UI风格")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin-top"
  }, [_vm._v("\n    Metro作为一种文字导向（typography-based）的设计，设计一般采用微软WP为此设计的标准字体：\"Segoe WP\"，它也比起其他UI设计风格更加注重字体，并且在持续不停进化中，原因是Metro的设计原则之一是\"content before chrome\"，翻译过来大致是“内容大于装饰”，所以这种设计风格更加注重应用内容本身（一般以文字和线描图展现），而不是在于传统设计上的“Graphic”（图形），这也是当初它搭配在Lumia上一出世就把大家惊艳到的主要因素。  \n  ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin-top"
  }, [_vm._v("\n    这种基于瑞士平面设计的设计原则，有利于设计出以文字为主的导航界面。机场和地铁的指示牌给了微软设计团队灵感，其风格大量采用大字体，能吸引观众之注意力。微软认为Metro设计主题应该是：“光滑、快、现代”（Simple.Clean.Modern），于是现在你看到的Metro的图标设计也不同于Android和iOS，即便它还是有不少的传统意义上的图标。 \n  ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_vm._v("\n    CSS参考："), _c('a', {
    staticClass: "fg-steel",
    attrs: {
      "href": "https://metroui.org.ua/"
    }
  }, [_vm._v("Metro UI CSS")])]), _vm._v(" "), _c('h4', {
    staticClass: "fg-cyan no-margin-bottom"
  }, [_vm._v("组件引用")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_vm._v("\n    1. 所有组件都以.vue文件形式包含在源码中，可以单独拿出来使用，没有样式依赖。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_vm._v("\n    2. 其中包含四个组件（alert、confirm、message、loading），也可以单独拿出来使用\n  ")]), _vm._v(" "), _c('h4', {
    staticClass: "fg-cyan no-margin-bottom"
  }, [_vm._v("联系作者\b")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel"
  }, [_vm._v("\n    如果有任何疑问，可以通过以下的方式联系作者:\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" \n    "), _c('a', {
    staticClass: "fg-steel",
    attrs: {
      "href": "https://www.github.com/watson-yan"
    }
  }, [_vm._v("https://www.github.com/watson-yan")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" \n    "), _c('a', {
    staticClass: "fg-steel",
    attrs: {
      "href": "mailto:watson-y@outlook.com"
    }
  }, [_vm._v("watson-y@outlook.com")])]), _vm._v(" "), _c('h4', [_vm._v("如果喜欢整个文档界面风格，附源码:(记得star哦\b\b😆)")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_c('a', {
    staticClass: "fg-steel",
    attrs: {
      "href": "https://github.com/watson-yan/viui-doc",
      "target": "_blank"
    }
  }, [_vm._v("\bGithub地址")])])])
}]}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Size 大小")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"button small\">Small</button>\n<button class=\"button\">Default</button>\n<button class=\"button large\">Large</button>\n<button class=\"button large\" disabled>Disabled</button>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Color 颜色")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', [_vm._v("<button class=\"button primary\">Primary</button>\n<button class=\"button success\">Success</button>\n<button class=\"button info\">Info</button>\n<button class=\"button danger\">Danger</button>\n<button class=\"button warning\">Warning</button>\n<button class=\"button link\">Link</button>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Shape 形状")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(2), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"square-button mini\">m</button>\n<button class=\"square-button small\">S</button>\n<button class=\"square-button\">D</button>\n<button class=\"square-button large\">L</button>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"cycle-button mini\">m</button>\n<button class=\"cycle-button small\">S</button>\n<button class=\"cycle-button\">D</button>\n<button class=\"cycle-button large\">L</button>\n")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Icon-button 带Icon的按钮  (Font-awesome)")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"button large info\">\n  <i class=\"fa fa-commenting\"></i> Comment</button>\n<button class=\"button large primary\">\n  <i class=\"fa fa-check\"></i> Submit</button>\n<button class=\"button large danger\">\n  <i class=\"fa fa-remove\"></i> Cancel</button>")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Outline-button 线形按钮")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<button class=\"button primary outline\">primary</button>\n<button class=\"button success outline\">success</button>\n<button class=\"button info outline\">info</button>\n<button class=\"button warning outline\">warning</button>\n<button class=\"button danger outline\">danger</button>")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Button-group 按钮组")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(6), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"btn-group\">\n  <button class=\"button\">One</button>\n  <button class=\"button\">Two</button>\n  <button class=\"button\">Three</button>\n</div>")])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"btn-group\">\n  <button class=\"square-button primary outline\">\n    <i class=\"fa fa-plus\"></i>\n  </button>\n  <button class=\"square-button primary outline\">\n    <i class=\"fa fa-pencil\"></i>\n  </button>\n  <button class=\"square-button primary outline\">\n    <i class=\"fa fa-download\"></i>\n  </button>\n</div>")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('button', {
    staticClass: "button small"
  }, [_vm._v("Small")]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Default")]), _vm._v(" "), _c('button', {
    staticClass: "button large"
  }, [_vm._v("Large")]), _vm._v(" "), _c('button', {
    staticClass: "button large",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('button', {
    staticClass: "button primary"
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "button success"
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "button info"
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "button danger"
  }, [_vm._v("Danger")]), _vm._v(" "), _c('button', {
    staticClass: "button warning"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "button link"
  }, [_vm._v("Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "square-button mini"
  }, [_vm._v("m")]), _vm._v(" "), _c('button', {
    staticClass: "square-button small"
  }, [_vm._v("S")]), _vm._v(" "), _c('button', {
    staticClass: "square-button"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "square-button large"
  }, [_vm._v("L")]), _vm._v(" "), _c('button', {
    staticClass: "square-button primary"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "square-button info"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "square-button danger"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "square-button warning"
  }, [_vm._v("D")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "cycle-button mini"
  }, [_vm._v("m")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button small"
  }, [_vm._v("S")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button large"
  }, [_vm._v("L")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button primary"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button info"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button danger"
  }, [_vm._v("D")]), _vm._v(" "), _c('button', {
    staticClass: "cycle-button warning"
  }, [_vm._v("D")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('button', {
    staticClass: "button large info"
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  }), _vm._v(" Comment")]), _vm._v(" "), _c('button', {
    staticClass: "button large primary"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button large danger"
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Cancel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "box"
  }, [_c('button', {
    staticClass: "button primary outline"
  }, [_vm._v("primary")]), _vm._v(" "), _c('button', {
    staticClass: "button success outline"
  }, [_vm._v("success")]), _vm._v(" "), _c('button', {
    staticClass: "button info outline"
  }, [_vm._v("info")]), _vm._v(" "), _c('button', {
    staticClass: "button warning outline"
  }, [_vm._v("warning")]), _vm._v(" "), _c('button', {
    staticClass: "button danger outline"
  }, [_vm._v("danger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("One")]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Two")]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Three")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "square-button primary outline"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button primary outline"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button primary outline"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])])
}]}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Dropdown 下拉按钮")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('section', {
    staticClass: "pull-left padding15"
  }, [_c('dropdown', {
    attrs: {
      "title": '下拉菜单',
      "menu": _vm.menu
    },
    on: {
      "choice": _vm.choice
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "pull-right padding15"
  }, [_c('dropdown', {
    attrs: {
      "title": '下拉菜单',
      "menu": _vm.menu,
      "right": true
    },
    on: {
      "choice": _vm.choice
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Html代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--菜单居左-->\n<dropdown :title=\"'下拉菜单'\" :menu=\"menu\" @choice=\"choice\"></dropdown>\n<!--菜单居右-->\n<dropdown :title=\"'下拉菜单'\" :menu=\"menu\" :right=\"true\" @choice=\"choice\"></dropdown>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("js代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v(" data() {\n  return {\n    menu: [\n      { value: 0, content: 'Action1' },\n      { value: 1, content: 'Action2' },\n      { value: 2, content: 'Action3' },\n      { value: 3, content: 'Action4' },\n      { value: 4, content: 'Action5', disabled: true },\n      { value: 5, content: 'Action6' }\n    ]\n  }\n},\nmethods: {\n  choice(val) {\n    this.$message({\n      caption: '成功',\n      content: `你选择了${this.menu[val].content}`,\n      type: 'info'\n    })\n  }\n}\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Binding attributes 绑定属性")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("'Menu'")]), _vm._v(" "), _c('td', [_vm._v("按钮显示的文字")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("menu")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("显示的菜单列表")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("是否右侧对齐")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Attribute Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Argument")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("choice")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("n(选中项的value)")]), _vm._v(" "), _c('td', [_vm._v("选中菜单某一项后的回调事件")])])])])
}]}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Table 表格")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', [_vm._v("通过下面的复选框按钮来为表格增加样式")]), _vm._v(" "), _c('section', [_c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.className),
      expression: "className"
    }],
    attrs: {
      "type": "checkbox",
      "value": "striped"
    },
    domProps: {
      "checked": Array.isArray(_vm.className) ? _vm._i(_vm.className, "striped") > -1 : (_vm.className)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.className,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "striped",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.className = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.className = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.className = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("striped(条纹、斑马效果)")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.className),
      expression: "className"
    }],
    attrs: {
      "type": "checkbox",
      "value": "hovered"
    },
    domProps: {
      "checked": Array.isArray(_vm.className) ? _vm._i(_vm.className, "hovered") > -1 : (_vm.className)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.className,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "hovered",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.className = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.className = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.className = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("hovered(鼠标悬浮效果)")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.className),
      expression: "className"
    }],
    attrs: {
      "type": "checkbox",
      "value": "cell-hovered"
    },
    domProps: {
      "checked": Array.isArray(_vm.className) ? _vm._i(_vm.className, "cell-hovered") > -1 : (_vm.className)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.className,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "cell-hovered",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.className = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.className = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.className = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("cell-hovered(鼠标单元格悬浮效果)")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.className),
      expression: "className"
    }],
    attrs: {
      "type": "checkbox",
      "value": "border"
    },
    domProps: {
      "checked": Array.isArray(_vm.className) ? _vm._i(_vm.className, "border") > -1 : (_vm.className)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.className,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "border",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.className = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.className = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.className = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("border(外边界效果)")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.className),
      expression: "className"
    }],
    attrs: {
      "type": "checkbox",
      "value": "bordered"
    },
    domProps: {
      "checked": Array.isArray(_vm.className) ? _vm._i(_vm.className, "bordered") > -1 : (_vm.className)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.className,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "bordered",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.className = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.className = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.className = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("bordered(内边界效果)")])])]), _vm._v(" "), _c('table', {
    class: _vm.clsName
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--默认-->\n<table class=\"table\">...</table>\n<!--striped(条纹、斑马效果)-->\n<table class=\"table striped\">...</table>\n<!--hovered(鼠标悬浮效果)-->\n<table class=\"table hovered\">...</table>\n<!--cell-hovered(鼠标单元格悬浮效果)-->\n<table class=\"table cell-hovered\">...</table>\n<!--border(外边界效果)-->\n<table class=\"table border\">...</table>\n<!--bordered(内边界效果)-->\n<table class=\"table bordered\">...</table>\n")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Column1")]), _vm._v(" "), _c('th', [_vm._v("Column2")]), _vm._v(" "), _c('th', [_vm._v("Column3")]), _vm._v(" "), _c('th', [_vm._v("Column4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_vm._v("a")]), _vm._v(" "), _c('td', [_vm._v("b")]), _vm._v(" "), _c('td', [_vm._v("c")]), _vm._v(" "), _c('td', [_vm._v("d")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("a")]), _vm._v(" "), _c('td', [_vm._v("b")]), _vm._v(" "), _c('td', [_vm._v("c")]), _vm._v(" "), _c('td', [_vm._v("d")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("a")]), _vm._v(" "), _c('td', [_vm._v("b")]), _vm._v(" "), _c('td', [_vm._v("c")]), _vm._v(" "), _c('td', [_vm._v("d")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("a")]), _vm._v(" "), _c('td', [_vm._v("b")]), _vm._v(" "), _c('td', [_vm._v("c")]), _vm._v(" "), _c('td', [_vm._v("d")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("a")]), _vm._v(" "), _c('td', [_vm._v("b")]), _vm._v(" "), _c('td', [_vm._v("c")]), _vm._v(" "), _c('td', [_vm._v("d")])])])
}]}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Switch 开关")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "fg-gray no-margin-bottom"
  }, [_vm._v("Modern 现代风格")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"switch\">\n  <input type=\"checkbox\">\n  <span class=\"check\"></span>\n</label>\n\n<label class=\"switch\">\n  <input type=\"checkbox\" checked>\n  <span class=\"check\"></span>\n</label>\n")])]), _vm._v(" "), _c('p', [_vm._v("禁用状态")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"switch\">\n  <input type=\"checkbox\" disabled>\n  <span class=\"check\"></span>\n</label>")])])]), _vm._v(" "), _c('section', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "fg-gray"
  }, [_vm._v("Original 传统风格")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"switch-original\">\n  <input type=\"checkbox\">\n  <span class=\"check\"></span>\n</label>\n\n<label class=\"switch-original\">\n  <input type=\"checkbox\" checked>\n  <span class=\"check\"></span>\n</label>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("禁用状态")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"switch-original\">\n  <input type=\"checkbox\" disabled>\n  <span class=\"check\"></span>\n</label>")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-original"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-original"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-original"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-original"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  })])
}]}

/***/ })
]),[120]);


// WEBPACK FOOTER //
// static/js/app.f51b46eb4f49383c704f.js